import { takeLatest, select, put } from 'redux-saga/effects';
import size from 'lodash/size';

import * as updateAssignment from '../assignment-update-req';
import * as pendingAssignments from '../assignment-pending-req';
import * as reviewedAssignments from '../assignment-reviewed-req';
import {
  selectPendingAssignmentList,
  selectReviewedAssignmentList,
  selectPendingAssignmentListCount,
} from '../selectors';

function* handleResolveAssignments() {
  const FIRST_REQUEST_LIMIT = 10;
  const counter = yield select(selectPendingAssignmentListCount);
  const reviewedList = yield select(selectReviewedAssignmentList);
  const pendingList = yield select(selectPendingAssignmentList);

  if (counter >= FIRST_REQUEST_LIMIT) {
    yield put(
      pendingAssignments.paginationActions.send({
        limit: 1,
        offset: size(pendingList),
      }),
    );
  }

  yield put(
    reviewedAssignments.actions.send({
      silent: true,
      limit:
        size(reviewedList) < FIRST_REQUEST_LIMIT
          ? FIRST_REQUEST_LIMIT
          : size(reviewedList),
    }),
  );
}

export default function* resolveAssignments() {
  yield takeLatest([updateAssignment.consts.SUCCEED], handleResolveAssignments);
}



// WEBPACK FOOTER //
// ./src/redux/dependentManagement/sagas/resolveAssignments.js